<template>
<div class="interiorzone">
    <div class="toptit"><h2 class=" fl subheading">文案设置</h2><button @click="backtoup()">返回列表</button></div>
    <div class="contentbox">
      <div class="hello">
        <div class="workarea">
          <div class="articlebox">
            <label>文章标题：</label>
            <input type="text" class="articletitle" v-model="simtit">
          </div>
          <div class="abc">
            <div class="halfbox fl">
            <label class="adclab">使用类型：</label>
              <el-radio v-model="radio" label="1">web</el-radio><el-radio v-model="radio" label="2">H5</el-radio><el-radio v-model="radio" label="3">小程序</el-radio>
            </div>
            <div class="halfbox fl">
              <label>备注：</label>
              <input type="text" v-model="articledesc"/>
            </div>
          </div>
          <div class="articlebox">
            <div class="halfboxbig fl">
              <label class="abclab">位置标签：</label>
              <el-radio v-model="tagattribute" label="1">幻灯片广告</el-radio><el-radio v-model="tagattribute" label="2">产品介绍</el-radio><el-radio v-model="tagattribute" label="3">推广文案</el-radio><el-radio v-model="tagattribute" label="4">图文广告</el-radio>
            </div>
            <div class="weight fl">
              <label>权重：</label>
              <input type="text" v-model="weight"/>
            </div>
          </div>
          <div class="posterbox">
            <div class="describe fl">
              <label>Banner：</label>
              <input type="text" class="newinput fl" v-model="bannerurl"/>
              <div class="uptobanner fl">封面上传
                <input type="file" class="uplicense imga" accept="image/png,image/jpeg,image/jpg" @change="uptobanner($event)" />
              </div>
              <div class="uptobanner fl" @click="bannersoak">插入正文</div>
            </div>
            <div class="reviewbox" > 
              <img :src="bannerurl" />
              <div class="span" :class="bannerurl!=''?'on':''" :title="bannerurl==''?'请点击左侧上传按钮上传banner图片':''">点击预览</div> 
              <a href="javascript:void(0);" v-if="bannerurl!=''" @click="lookimg"></a>
            </div>
          </div>
          <div class="articlebox">
            <div class="halfboxbig fl" style="width:800px;">
              <label class="abclab">文章类型：</label>
              <el-radio v-model="articlestyle" label="1">文章</el-radio><el-radio v-model="articlestyle" label="2">专题</el-radio><el-radio v-model="articlestyle" label="3">链接</el-radio><el-radio v-model="articlestyle" label="4">全屏专题</el-radio>
            </div>
          </div>
          <vue-ueditor-wrap ref="ueditor" v-model="msg" :destroy="destruction" :config="config" @ready="ready"  @beforeInit="addCustomUI"></vue-ueditor-wrap>
          <div class="buttonbox">
            <button class="subtn" @click="subarticle()">提交</button>
            <button class="subtn" @click="backtoup()">取消</button>
          </div>
        </div>
        <div class="simulator">
          <div class='top-nav-bar'><span class="nav-bar__title">{{simtit}}</span></div>
          <div class="articlecontent" v-html="msg"></div>
        </div>
        <div class="zzc seeban" v-if="seebanner" @click="closesee">
          <img :src="bannerurl" >
        </div>
        <div class='zzc' v-if="useimg">
          <div class="edui-dialog mtmtk edui-for-test-dialogeditor_e33de5 edui-default edui-state-centered">
            <div class="edui-dialog edui-for-test-dialogeditor_e33de5 edui-default">
              <div class="edui-dialog-body edui-default" style="width: 602px; height: 329px;">
                  <div class="edui-dialog-shadow edui-default"></div>
                  <div class="edui-dialog-titlebar edui-default">
                      <div class="edui-dialog-draghandle edui-default" ><span class="edui-dialog-caption edui-default">图片上传</span>
                      </div>
                      <div class="edui-box edui-button edui-dialog-closebutton edui-default" @click="exitpic()">
                          <div class="edui-default">
                              <div class="edui-button-wrap edui-default">
                                  <div unselectable="on" class="edui-button-body edui-default">
                                      <div class="edui-box edui-icon edui-default"></div>
                                      <div class="edui-box edui-label edui-default"></div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="edui-dialog-content edui-default"><span class="dialogcontmask"></span>
                  <ul class="upto"><li :class="selectorup=='1'?'on':''" @click="setuporinse(1)">上传图片</li><li  :class="selectorup=='2'?'on':''" @click="setuporinse(2)">选择图片</li></ul>
                    <div class="upimg" v-if="selectorup=='1'">
                      <section class="upbox">
                        <input type="file" class="uplicense imga" id="id"  ref="inputer"  @change="addImga($event)"   accept="image/png,image/jpeg,image/jpg"/>
                        <section class="supreme" v-if="isup"></section>
                      </section>
                    </div>
                    <div class="seletimgbox" v-else>
                      <ul>
                        <li v-for="(item,index) in allimglist" class="picbox" :key="index" @click="hchc(item)"><img :src="item" alt=""/></li>
                      </ul>
                    </div>
                    <div class="setpicwh" v-if="insertimg!=''">
                      <img :src="insertimg" class="insertimg" @click="nowimg">
                      <div class="imgsetbox">
                        <div class="inpsetbox">
                          <label>宽度：</label><input type="text" v-model="insimgw" @blur="calcheight"><span>px</span>
                        </div>
                        <div  class="inpsetbox">
                          <label>高度：</label><input type="text"  v-model="insimgh" @blur="calcwidth"><span>px</span>
                        </div>
                      </div>
                      <p class="tipsimg">*小程序只适用最大宽度375px图片</p>
                      <div class="imginsert" @click="fillpic()">插入图片</div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
export default {
  name: 'adve',
  // 2、注册组件
  components: {
    VueUeditorWrap
  },
  inject:['reload'],
  data () {
    return {
      msg:'',
      simtit:'',
      radio:'3',
      allimglist:[],
      isup:false,
      bannerurl:'',
      selectorup:'1',
      tagattribute:'1',
      weight:'0',
      articledesc:'',
      nowid:0,
      destruction:false,
      useimg:false,
      insimgw:'',
      insimgh:'',
      wbasevalue:'',//宽度基值
      hbasevalue:'',//高度基值
      seebanner:false,
      articlestyle:'1',
      insertimg:'',
      // 4、根据项目需求自行配置,具体配置参见ueditor.config.js源码或 http://fex.baidu.com/ueditor/#start-start
      config: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%'
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        //serverUrl: 'http://35.201.165.105:8000/controller.php'
        //serverUrl:'http://api.borntrust.com.cn/upload/fastdfsUpload'
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        // UEDITOR_HOME_URL: '/static/UEditor/'
        // 配合最新编译的资源文件，你可以实现添加自定义Request Headers,详情https://github.com/HaoChuan9421/ueditor/commits/dev-1.4.3.3
        // headers: {
        //   access_token: '37e7c9e3fda54cca94b8c88a4b5ddbf3'
        // }
      }
    }
  },
  mounted () {
    //需要把引入进来的数据导入并保存到缓存中 并 在页面关闭时销毁

    let adc=this.$route.params.advinfo||JSON.parse(localStorage.getItem('advinfo'))
    if(adc){
      this.msg=adc.content
      this.simtit=adc.adTile
      this.radio=''+adc.deviceType
      this.bannerurl=adc.adPicUrl
      this.tagattribute=''+adc.scope
      this.weight=''+adc.weight
      this.articledesc=adc.scopeDesc
      this.nowid=adc.id
      if(!localStorage.getItem('advinfo')){
        localStorage.setItem('advinfo', JSON.stringify(this.$route.params.advinfo));
      }
    }
    else{
      location.href='/bankacceptance/advlist'
    }
  },
  methods: {
    // 5、 你可以在ready方法中拿到editorInstance实例,所有API和官方的实例是一样了。http://fex.baidu.com/ueditor/#api-common
    ready (editorInstance) {
      console.log(`实例${editorInstance.key}已经初始化:`, editorInstance)
    },
    // 6. 查看绑定的数据
    showData () {
      alert(this.msg)
      console.log(this.msg)
    },
    // 7. 借助 beforeInit 钩子，你可以实现对 UEditor 的二次开发，会在 scripts 加载完毕之后、编辑器初始化之前触发，以 编辑器 id 和 配置参数 作为入参
    addCustomUI (editorId, editorConfig) {
      console.log(editorId + '的配置参数是:', JSON.stringify(editorConfig, null, 2))
      var _this=this
      // 1. 自定义按钮
      window.UE.registerUI('test-button' + editorId, function (editor, uiName) {
        // 注册按钮执行时的 command 命令，使用命令默认就会带有回退操作
        editor.registerCommand(uiName, {
          execCommand: function () {
            //用此方法插入图片 需要img 配合
            editor.execCommand('inserthtml', `<span style="color: #${editorId.substr(-3)};">这是一段由自定义按钮添加的文字，你点击的编辑器ID是${editorId}</span>`)
          }
        })

        // 创建一个 button
        var btn = new window.UE.ui.Button({
          // 按钮的名字
          name: uiName,
          // 提示
          title: '插入图片',
          // 需要添加的额外样式，可指定 icon 图标，图标路径参考常见问题 2
          cssRules: "background-position: -380px 0px;",
          // 点击时执行的命令
          onclick: function () {
            // 这里可以不用执行命令，做你自己的操作也可
            _this.useimg=true
          }
        })

        // 当点到编辑内容上时，按钮要做的状态反射
        editor.addListener('selectionchange', function () {
          var state = editor.queryCommandState(uiName)
          if (state === -1) {
            btn.setDisabled(true)
            btn.setChecked(false)
          } else {
            btn.setDisabled(false)
            btn.setChecked(state)
          }
        })

        // 因为你是添加 button，所以需要返回这个 button
        return btn
      }, 36 /* 指定添加到工具栏上的哪个位置，默认时追加到最后 */, editorId /* 指定这个 UI 是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */)
    },
    imginsert(key){
      console.log(key)
       window.UE.getEditor('editor').setContent('欢迎使用ueditor', isAppendTo);
    },
    setuporinse(val){
      this.selectorup=val
    },
    addImga(e,val){
      let file = e.target.files[0]
      let mbyte=Number(file.size)/1024/1024
      if(mbyte>2){
        swal({
          text: '图片过大，请使用小于2MB的文件！~',
          timer: 2000,
          buttons: false
        })
      }
      else{
        this.isup=true
        let param = new FormData()
        param.append('file', file, file.name)
        this.upimg(param).then(resolve=>{
          if(resolve!=""){
            this.isup=false
            this.allimglist.push(this.versatile.imgUrl+resolve)
            this.insertimg=this.versatile.imgUrl+resolve
            this.nowimg(this.insertimg)
            this.selectorup='2'
          }
        })
      }
    },
    uptobanner(e){
      let file = e.target.files[0]
      let mbyte=Number(file.size)/1024/1024
      if(mbyte>2){
        swal({
          text: '图片过大，请使用小于2MB的文件！~',
          timer: 2000,
          buttons: false
        })
      }
      else{
        let param = new FormData()
        param.append('file', file, file.name)
        this.upimg(param).then(resolve=>{
          if(resolve!=""){
            this.bannerurl=this.versatile.imgUrl+resolve
          }
        })
      }
    },
    upimg(val){
      return this.ajax.post('/upload/fastdfsUpload',val)
        .then(resolve => {
          if(resolve.data.status=="0000"){
            return Promise.resolve(resolve.data.data) ;
          }
          else{
            swal({
              text: resolve.data.message,
              timer: 2000,
              buttons: false
            })
            return Promise.resolve("")
          }
        }
      )
    },
    bannersoak(){
      let a=this.bannerurl
      if(a!=''){
        this.msg=this.msg+"<img src='"+a+"'/>"
      }
      else{
        this.$alert('点击左侧 封面上传 按钮即可上传图片，请在上传完成后操作！', '请先上传banner图', {
          confirmButtonText: '确定',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        });
      }
    },
    exitpic(){
      this.useimg=false
    },
    fillpic(){
      if(this.radio==3&&this.insimgw>375){
        this.$alert('小程序广告图文最大值不能超出375像素', '严重错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      else if(this.insimgw==''){
        this.$alert('请设置图片宽度', '严重错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      else if(this.insimgh==''){
        this.$alert('请设置图片高度', '严重错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      else{
        console.log("<img src='"+this.insertimg+"' style='width:"+this.insimgw+"px;height:"+this.insimgh+"px'/>")
        this.msg=this.msg+"<p><img src='"+this.insertimg+"' width='"+this.insimgw+"'  height='"+this.insimgh+"'/></p>"
        this.insertimg=''
        this.insimgw=''
        this.insimgh=''
        this.useimg=false
      }
    },
    hchc(val){
      this.insertimg=val
      this.nowimg(val)
    },
    backtoup(){
      this.destruction=true;
      location.href='/bankacceptance/advlist'
    },
    nowimg(val){
      let _this=this
      let img = new Image()
      img.src = val
      img.onload = function () {
        _this.insimgw=img.width
        _this.wbasevalue=img.width
        _this.insimgh=img.height
        _this.hbasevalue=img.height
      }
    },
    calcheight(){
      this.insimgh=this.insimgw/this.wbasevalue*this.insimgh
    },
    calcwidth(){
      this.insimgw=this.insimgh/this.hbasevalue*this.insimgw
    },
    subarticle(){
      if(this.bannerurl==''&&this.tagattribute=='1'){
        this.$alert('此广告位必须上传banner封面图，否则会影响广告位的展示', '严重错误', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
      else{
        this.ajax.post("/advertising/editAdvertising",{bizContent: {id:this.nowid,adHead:this.articlestyle,adPicUrl:this.bannerurl,deviceType: this.radio,scope:this.tagattribute,scopeDesc: this.articledesc,weight:this.weight,adTile:this.simtit,content:this.msg}})
        .then(
          result=>{
            if(result.data.status=='0000'){
              this.$alert(result.data.message, '系统提示', {
                confirmButtonText: '确定',
                callback: action => {
                  location.href='/bankacceptance/advlist'
                }
              });
            }
            else{
              this.$alert(result.data.message, '系统提示', {
                confirmButtonText: '确定',
                callback: action => {
                }
              });
            }
          }
        )
      }
    },
    lookimg(){
      this.seebanner=true
    },
    closesee(){
      this.seebanner=false
    }
  },
  beforeDestroy(){
    localStorage.removeItem('advinfo')
    this.destruction=true
    this.reload()
  }
}
</script>

<style scoped>
.toptit{
  width:100%;
  display:table;
  clear:both;
  margin-bottom:20px;
}
.toptit button{
  float:left;
  margin-left:30px;
  width:111px;
  height:39px;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 7px 0px rgba(61,143,226,0.43);
  border-radius:2px;
  color:#fff;
  margin-top:3px;
  cursor:pointer;
}
.toptit button.interest{
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 7px 0px rgba(61,143,226,0.43);
  border-radius:2px;
  border:1px solid rgba(61,143,226,1);
  color: #3D8FE2;
}
.preview{
  min-height: 150px;
}
.articlebox{
  width:100%;
  height:34px;
  line-height: 34px;
  display: block;
  margin:10px auto;
  overflow: hidden;
  border-bottom: 1px dotted #adadad;
  padding: 5px 0;
}
.abc{
    width:100%;
    height:34px;
    margin:10px auto;
    padding: 5px 0;
    border-bottom: 1px dotted #adadad;
}
.articlebox label,.posterbox  label ,.abclab,.halfbox label,.describe label{
  width:100px;
  height:34px;
  line-height: 34px;
  text-indent: 14px;
  font-size: 14px;
  display: block;
  float: left;
}
.posterbox{
  width:100%;
  display: block;
  height:105px;
  margin:10px auto;
  overflow: hidden;
  border-bottom: 1px dotted #adadad;
  padding-bottom: 5px;
}
.posterbox .describe{
  padding:33px 0;
}
.posterbox .describe input.newinput{
  width:calc(70% - 102px);
}
.articletitle{
  float: left;
  width:calc(100% - 102px);
  background: #fff url("../../assets/ruler.gif")  left 8px repeat-x;
  
}
.articlebox input,.posterbox input,.halfbox input{
  border:1px solid #c3c3c3;
  height:32px;
  line-height:32px;
  text-indent: 8px;
}
.articletitle:focus,.articlebox input:focus,.newinput:focus{
  border:1px solid #409EFF;
}
.scoperange{
  float: left;
  height:34px;
  line-height:34px;
  overflow: hidden;
  margin-top:12px !important;
}
.scoperange label{
  margin-top:12px !important;
}
.describe{width:70%;}
.weight{width:30%;}
.describe input,.weight input,.halfbox input{
  width:calc(100% - 102px);
  background: #fff;
}
.weight label:first-child,.halfbox label:first-child{
  text-align: center;
}
.workarea{
  width:calc(60%);
  margin-left:2%;
  display: table;
  float: left;
}
.simulator{
  width:375px;
  height:667px;
  left:62%;
  top:16%;
  margin-left:5%;
  -webkit-box-shadow: #ebedf0 0 4px 12px;
  box-shadow: 0 4px 12px #ebedf0;
  background-color: #F2F2F2;
  position:absolute;
  font-family: -apple-system-font,BlinkMacSystemFont,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei UI","Microsoft YaHei",Arial,sans-serif;
}
.top-nav-bar {
  height: 64px;
  line-height: 64px;
  width:100%;
  position: relative;
  border-bottom: 1px solid 0.5px;
  background-color: #fff;
}
.nav-bar__title {
  width: 90%;
  margin: 0 auto;
  color: #323233;
  font-weight: 500;
  font-size: 15px;
  display: block;
  text-align: center;
  margin:0 5%;
  font-family: -apple-system-font,BlinkMacSystemFont,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei UI","Microsoft YaHei",Arial,sans-serif;
}
.nav-bar__back{
  position: absolute;
  left:5px;
  top:5px;
}
.articlecontent{
  width:335px;
  padding:20px;
  display: block;
  font-size: 16px;
  max-height: 560px;
  overflow: hidden;
  overflow-y: auto;
  font-family: -apple-system-font,BlinkMacSystemFont,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei UI","Microsoft YaHei",Arial,sans-serif;
}

.mtmtk{
  position:absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  vertical-align: middle;
  display: table;
  margin: auto;
  width: 602px;
  height: 329px;
}
.seeban img{
  position:fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  vertical-align: middle;
  display: table;
  margin: auto;
}
.zzc{
  z-index: 1000;
}
.edui-default .edui-dialog-titlebar{
  cursor: default;
}
.upto{
  width:90%;
  padding:0 5%;
  height:30px;
  line-height:30px;
  background: linear-gradient(#fff, #efefef); 
}
.upto li{
  width: 50%;
  height:30px;
  line-height:30px;
  text-align: center;
  background: linear-gradient(#fff, #efefef); 
  float: left;
  font-size:14px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.upto li:hover{
  opacity: 0.8;
}
.upto li.on{
  background: #fff;
  display: block;
  color:#333;
  content: ''
}
.upto li.on:hover{
  opacity: 1;
}
.upbox{
 width:160px;
 height:160px;
 background: #fff url('../../assets/upimg.png') 50% no-repeat;
 border:1px solid #efefef;
 margin:40px auto;
 overflow: hidden;
 background-size: 50%;
 position: relative;
}
.uplicense{
  width:200px;
  height:200px;
  display: block;
  opacity: 0;
}
.supreme{
  width:160px;
  height:160px;
  position: absolute;
  left:0;
  top:0;
  background: #efefef url('../../assets/20130527034918234.gif') 50% no-repeat;
}
.picbox{
  float: left;
  width: 182px;
  height: 90px;
  margin: 20px;
}
.uptobanner{
  position: relative;
  width:70px;
  height:32px;
  line-height: 32px;
  background: linear-gradient(#fff, #efefef); 
  color:#333;
  margin-left:12px;
  margin-right:12px;
  border:1px solid #cfcfcf;
  font-size:14px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
  cursor: pointer;
}
.picbox img{
  max-width: 182px;
  max-height: 120px;
}
.uptobanner .uplicense{
  position: absolute;
  left:0;
  top:0;
  width:200px;
  height:200px;
  display: block;
  opacity: 0;
  cursor: pointer;
}
.reviewbox{
  width:150px;
  height:100px;
  background: #EFEBE7;
  text-align: center;
  vertical-align: middle;
  float:right;
  line-height:100px;
  margin-right:100px;
  font-size: 12px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.reviewbox a{
  position: absolute;
  left:0;
  top:0;
  width:100%;
  height:100%;
  display:block;
  z-index:99;
}
.reviewbox .span{
  width:150px;
  height:100px;
  position: absolute;
  left: 0;
  top: 0;
  right:0;
  bottom:0;
  vertical-align: middle;
  margin:0 auto;
  text-align: center; 
  z-index: 2;
  color:#cfcfcf;
  background-color: rgba(255, 255, 255, 0.7);
}
.reviewbox .span.on{
  color: #333;
}
.reviewbox .span.on:hover{
  background-color: rgba(255, 255, 255, 0.9);
  color:#0066ff;
}
.reviewbox img{
  position: absolute;
  left: 0;
  top: 0;
  right:0;
  bottom:0;
  vertical-align: middle;
  text-align: center; 
  max-width: 150px;
  max-height:100px;
  margin:0 auto;
  z-index: 1;
}
.subtn{
  width:120px;
  height:30px;
}
.buttonbox{
  clear: both;
  height:30px;
  padding:18px 0;
  display: table;
  margin:0 auto;
}
.buttonbox button{
  width:200px;
  height:60px;
  text-align: center;
  line-height: 60px;
  border-radius:2px;
  font-size: 16px;
}
.buttonbox button:first-child{
  background:rgba(61,143,226,1);
  color:#fff;
box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
}
.buttonbox button:last-child{
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 8px 1px rgba(61,143,226,0.28);
  margin-left:18px;
}
.halfbox{
  width:460px;
}
.halfboxbig{
  width:633px;
}
label.adclab{
  text-align: left;
}
.setpicwh{
  background-color: #fff;
  width: 602px;
  height: 329px;
  position: absolute;
  left:0;
  top: 0;
}
.insertimg{
  text-align: center;
  margin:10px auto;
  display: table;
  max-width: 120px;
}
.inpsetbox{
  width:180px;
  height: 32px;
  line-height:32px;
  border: 1px solid #efefef;
  margin:20px; float: left;
}
.inpsetbox label{
  float: left;
  width:50px;
  font-size: 14px;
  text-align: center;
}
.inpsetbox input{
  float: left;
  width:100px;
  height: 32px;
}
.inpsetbox span{
  float: right;
  margin-right: 10px;
  color:#666;
  font-size: 14px;
  line-height: 32px;
}
.imgsetbox{
  display: table;
  margin:0 auto;
}
.tipsimg{
  text-align: center;
  line-height:200%;
  color:#666;
  font-size: 14px;
}
.imginsert{
  color: #fff;
  background-color: #3D8FE2;
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
  text-align: center;
  cursor: pointer;
  display: table;
  margin:0 auto;
  margin-top:28px;
}
</style>



// WEBPACK FOOTER //
// src/PAGE/bankAcceptance/adrepair.vue